<template>
    <div>
        <loading
            :active.sync="selectCategory.length == 0 || loading.content"
            :can-cancel="false"
            :is-full-page="true"
            :color="'#0B8BCC'"
            :loader="'dots'"
            :opacity="0.7"
            :lock-scroll="true"
        ></loading>
        <div class="appHeader bg-primary text-light shadow-header-footer">
            <div class="left">
                <a @click="$router.go(-1)" class="headerButton">
                    <ion-icon name="chevron-back-outline"></ion-icon>
                </a>
            </div>
            <div class="pageTitle">
                {{
                    selectCategory.length > 0
                        ? selectCategory[0].product_name
                        : 'Loading...'
                }}
            </div>
        </div>
        <div
            id="appCapsule"
            v-if="selectCategory.length > 0 && loading.content == false"
        >
            <div class="form-group boxed pl-1 pr-1" v-if="product.length > 10">
                <input
                    type="text"
                    class="form-control"
                    placeholder="Cari"
                    style="font-size: 13px"
                    v-model="keywords"
                />
            </div>
            <div class="section tab-content p-0">
                <ul class="listview image-listview">
                    <li v-for="item in filterProduct(product)" :key="item.id">
                        <router-link
                            style="cursor: pointer"
                            class="item pt-2 pb-2"
                            :to="{
                                name: 'order-pascabayar',
                                params: {
                                    id: selectCategory[0].id,
                                    title: selectCategory[0].product_name,
                                    product_data: item,
                                },
                            }"
                        >
                            <div class="image-overflow">
                                <img
                                    v-if="item.icon != null"
                                    v-lazyload
                                    :src="require('@/assets/Loader-3.png')"
                                    :data-src="
                                        VUE_ENV.VUE_APP_ASSET_URL +
                                        '/img/icon/operator/' +
                                        item.icon
                                    "
                                    alt="image"
                                    class="image"
                                />
                            </div>
                            <div class="in">
                                <div>
                                    <b>{{ item.product_name }}</b>
                                    <footer
                                        v-if="item.description != undefined"
                                    >
                                        {{ item.description }}
                                    </footer>
                                </div>
                            </div>
                        </router-link>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>
<script>
    import $axios from './../api.js';
    import { mapState } from 'vuex';
    export default {
        props: ['styleProduct'],
        data: () => ({
            loading: {
                content: true,
            },
            product: [],
            keywords: '',
        }),
        created() {
            // window.fbq('track', 'ViewContent');
        },
        computed: {
            ...mapState([
                'customer',
                'toast',
                'VUE_ENV',
                'device',
                'categoryPascabayar',
            ]),
            chunkProduct() {
                return window._.chunk(window._.toArray(this.product), 3);
            },
            selectCategory() {
                return this.categoryPascabayar.filter(item => {
                    return item.id == this.$route.params.id;
                });
            },
        },
        methods: {
            getProduct() {
                $axios
                    .post('/pascabayar/product', {
                        category_id: this.$route.params.id,
                    })
                    .then(response => {
                        this.product = response.data.data;
                        this.loading.content = false;
                    })
                    .catch(e => {
                        this.$store.commit('SET_TOAST', {
                            show: true,
                            message: e.response.data.message,
                            tipe: 'default',
                        });
                        this.loading.content = false;
                    });
            },
            filterProduct: function (product) {
                var app = this;
                return product.filter(function (item) {
                    let regex = new RegExp('(' + app.keywords + ')', 'i');
                    return item.product_name.match(regex);
                });
            },
        },
        mounted() {
            this.getProduct();
        },
    };
</script>
<style>
    .disabled-product {
        filter: grayscale(100%);
    }
</style>
